<template>
  <div :class="$style.root">
    <div :class="$style.container">
      <div :class="$style.list">
        <div
          v-for="project in projects"
          :key="project.slug"
          :class="$style.item"
          @click="toggleInfo(project.slug)"
        >
          <div :class="$style.itemContainer">
            <img
              :class="$style.img"
              :src="project.thumbnail"
              :alt="project.name"
              :srcset="`${project.thumbnail} 1x, ${project.thumbnail} 2x`"
              decoding="async"
            >
            <div
              :class="[
                $style.info,
                {
                  [$style.active]: activeProjectSlug === project.slug,
                }
              ]"
            >
              <h3 :class="$style.infoHeading">{{ project.name }}</h3>
              <p
                :class="$style.text"
                v-html="project.shortDescription" />
              <router-link
                :to="`/projects/${project.slug}`"
                :class="$style.link"
              >
                Смотреть
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projects } from 'data/mockProjects';
import ProjectsMore from 'components/ProjectsMore';

export default {
  name: 'ProjectsList',
  components: {
    ProjectsMore,
  },
  data() {
    return {
      projects,
      showInfo: false,
      activeProjectSlug: false,
    };
  },
  methods: {
    toggleInfo(projectSlug) {
      this.activeProjectSlug = this.activeProjectSlug !== projectSlug ? projectSlug : false;
    },
  },
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';

.root {
  @extend %container;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.container {
  @extend %section;
  @extend %content;

  max-width: 1110px;
  width: 100%;

  @include media('<desktop') {
    background-color: $white-gray;
    max-width: 100%;
  }
}

.heading {
  @extend %heading;
}

.infoHeading {
  font-size: 24px;
  line-height: 30px;
  font-weight: normal;
  margin-bottom: 10px;
  margin-top: 0;
  color: $white;

  @include media('<desktop') {
    color: $blue;
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  width: 100%;

  @include media('<desktop') {
    display: block;
  }
}

.item {
  flex-basis: calc(25% - 30px / 4);
  position: relative;
  overflow: hidden;

  @include media('>desktop') {
    .img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }

  &:hover .img {
    transform: scale(1.05);
  }
}

.itemContainer {
  @include media('>desktop') {
    padding-top: 100%;
  }
}

.link {
  @extend %button;
  @extend %buttonWhite;

  text-align: center;
  max-width: 160px;

  @include media('<desktop') {
    background-color: $red-light;
    color: $white;
  }
}

.info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  opacity: 0;
  transition: all $transitions-delay;

  @include media('<desktop') {
    $inherit: inherit;

    position: static;
    padding: 10px;
    opacity: 1;
    height: auto;
    background-color: $inherit;

    display: grid;
    grid-template-rows: 50px 1fr 45px;
    justify-items: center;
    margin-bottom: 20px;
  }
}

.info.active,
.info:hover {
  @include media('>=desktop') {
    opacity: 1;
    background-color: $red-transparent;
  }
}

.text {
  color: $white;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  max-height: 60%;
  text-wrap: pretty;

  @include media('<desktop') {
    color: $gray-dark;
  }
}

.img {
  @extend %hoverBlock;

  width: 100%;
  height: 100%;
  object-fit: cover;

  @include media('<desktop') {
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectsList.vue